export function generateLuhnForIccid(iccid: string): number | boolean {
  if (/[^0-9-\s]+/.test(iccid)) {
    return false;
  }

  let nCheck = 0;
  let nDigit = 0;
  let bEven = true;

  iccid = iccid.replace(/\D/g, '');

  for (let n = iccid.length - 1; n >= 0; n--) {
    const cDigit = iccid.charAt(n);
    nDigit = parseInt(cDigit, 10);

    if (bEven) {
      // tslint:disable-next-line:no-conditional-assignment
      if ((nDigit *= 2) > 9) { nDigit -= 9; }
    }

    nCheck += nDigit;
    bEven = !bEven;
  }
  return (1000 - nCheck) % 10;
}
